module.exports = __webpack_public_path__ + "img/exit_human_en.a5244e59.svg";